import styled, {ThemeProvider} from 'styled-components';

export const StyledThemeProvider = styled(ThemeProvider)`
  height: 100%;
`;
